import { createSlotOpenerDragPlugin } from './slotOpenerDragPlugin';
import { createSlotOpenerDragPluginAddPanel } from './slotOpenerDragPluginAddPanel';
import { getAvailableSlot } from './slotOpenerStore';

export const createSlotOpenerApi = () => ({
  dragPlugin: createSlotOpenerDragPlugin(),
  dragPluginAddPanel: createSlotOpenerDragPluginAddPanel(),
  getAvailableSlot,
});

export type SlotOpenerApi = ReturnType<typeof createSlotOpenerApi>;
